import { createContext, useContext, useEffect, useState } from "react";
import { api } from "./api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [agent, setAgent] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const stored = localStorage.getItem("if_agent");
    const token = localStorage.getItem("if_token");
    if (stored && token) {
      try {
        setAgent(JSON.parse(stored));
      } catch {}
    }
    setLoading(false);
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("if_token", data.access_token);
    localStorage.setItem("if_agent", JSON.stringify(data.agent));
    setAgent(data.agent);
    return data.agent;
  };

  const logout = () => {
    localStorage.removeItem("if_token");
    localStorage.removeItem("if_agent");
    setAgent(null);
  };

  return (
    <AuthContext.Provider value={{ agent, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
